module.exports = __webpack_public_path__ + "img/warning-icon.e2b6c98e.svg";